import { Component, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { ServiceSchedule } from '@app/core/api-azure-functions/dataverse-functions';
import { GoogleMapLocation } from '@app/core/models/google-map-location.model';
import {
  CustomerInvoices,
  SiteDetailsModel,
  SiteHaulerContractDocuments,
} from '@app/core/models/site.model';
import { ServiceScheduleHistoryModalComponent } from '@app/features/services/components/service-schedule-history-modal/service-schedule-history-modal.component';
import { CP_PERMISSIONS } from '@app/shared/app.constants';
import { PhonePipe } from '@app/shared/pipes/phone.pipe';
import { AuthSelectors, SiteActions, SiteSelectors } from '@app/store';
import { AppState } from '@app/store/app.state';
import { Store } from '@ngrx/store';
import { EMPTY, Observable, Subscription } from 'rxjs';
import { filter, map, switchMap, take } from 'rxjs/operators';

@Component({
  selector: 'app-site-detail-general',
  templateUrl: './site-detail-general.component.html',
  styleUrls: ['./site-detail-general.component.scss'],
  providers: [PhonePipe],
})
export class SiteDetailGeneralComponent implements OnDestroy {
  currentSite$: Observable<SiteDetailsModel> = this.store.select(
    SiteSelectors.getCurrentSite
  );
  currentSiteForMap$: Observable<GoogleMapLocation[]> = this.store.select(
    SiteSelectors.getCurrentSiteForMap
  );
  recurringServiceSchedules$: Observable<ServiceSchedule[]> = this.store.select(
    SiteSelectors.getCurrentActiveServiceSchedulesRecurring
  );
  onCallServiceSchedules$: Observable<ServiceSchedule[]> = this.store.select(
    SiteSelectors.getCurrentActiveServiceSchedulesOnCall
  );

  onSiteHaulerContractDocuments$: Observable<SiteHaulerContractDocuments[]> =
    this.store.select(SiteSelectors.getSiteHaulerContractDocuments);

  customerInvoices$: Observable<CustomerInvoices[]> = this.store.select(
    SiteSelectors.getCustomerInvoices
  );

  subscriptions: Subscription = new Subscription();
  customerInvoicesLoaded: boolean = false; // New flag to track API call state

  constructor(
    private store: Store<AppState>,
    public modal: MatDialog
  ) {}

  openModal() {
    this.modal.open(ServiceScheduleHistoryModalComponent);
  }

  tabChanged(tabChangeEvent: MatTabChangeEvent): void {
    if (tabChangeEvent.index === 1 && !this.customerInvoicesLoaded) {
      const userPermissions$ = this.store.select(
        AuthSelectors.getUserPermissions
      );
      const currentSite$ = this.currentSite$.pipe(filter(site => !!site));

      this.subscriptions.add(
        userPermissions$
          .pipe(
            map(userPermissions =>
              userPermissions.includes(CP_PERMISSIONS.SITES_INVOICE_READ)
            ),
            switchMap(isPermission => {
              if (!isPermission) {
                return EMPTY;
              }
              return currentSite$;
            }),
            take(1)
          )
          .subscribe(currentSite => {
            // Fetch invoices if all is well
            this.store.dispatch(
              SiteActions.getCustomerInvoicesBySite({
                customerId: currentSite.customerId,
                customerNumber: currentSite.accountNumber,
              })
            );
            this.customerInvoicesLoaded = true;
          })
      );
    }
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
